import React, { useEffect, useState } from "react";
import { useAuth } from "../../contexts/authContext";
import constants from "../../constants";
import axios from "axios";
import Loader from "../../util/loader";
import { Button, Card, Col, Divider, Row, Space, Statistic, Typography, Spin } from "antd";
import dayjs from "dayjs";
import { ArrowRightOutlined, ExpandAltOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

function Home() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [partner, setPartner] = useState({});
  const navigate = useNavigate();

  const { getToken } = useAuth();

  const { Title, Paragraph, Link, Text } = Typography;

  const fetchPartner = async () => {
    setLoading(true);
    try {
      const token = await getToken();
      const headers = {
        authorization: `bearer ${token}`,
      };
      const url = `${constants.NEW_DOMAIN}/api/v1/channelPartner/getPartner`;
      const res = await axios.get(url, { headers });

      setLoading(false);
      setPartner(res.data.data);
    } catch (error) {
      setLoading(false);
      setError(error.message || "something went wrong , try again later");
    }
  };

  useEffect(() => {
    fetchPartner();
  }, []);

  // {
  //         "_id": "68dfcc9f78061431625b2c38",
  //         "name": "Raghav",
  //         "email": "counsellor@gmail.com",
  //         "phone": "8770377254",
  //         "joiningDate": "2025-10-01T00:00:00.000Z",
  //         "totalCommisionEarned": 0,
  //         "commisionPending": 0,
  //         "tenureActiveUsers": 0,
  //         "totalActiveUsers": 0,
  //         "tenureExpiry": "2026-10-01T00:00:00.000Z",
  //         "createdAt": "2025-10-03T13:16:15.241Z",
  //         "updatedAt": "2025-10-03T13:16:15.241Z",
  //         "__v": 0,
  //         "firebaseId": "v0o9bKLZayMPU9ksJksHYxBPND42"
  //     }

  if (loading) {
    return (
      <div style={{ padding: 24, background: "#f7f8fa", minHeight: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div style={{ padding: "20px" }}>
      <Title level={2}>Welcome {partner.name} !</Title>
      <Text level={3}>
        CODE : <Link copyable>{partner._id}</Link>
      </Text>
      <br />

      <Text code italic>
        Joined on {dayjs(partner.joiningDate).format("DD MMM YYYY")}
      </Text>
      <Divider orientation="right"></Divider>

      <Space direction="vertical">
        <Text level={3}>
          Affiliate link for DUBAI: <Link copyable>https://youvah.fillout.com/t/tBrrvHyqTius?partnerId={partner._id}&programCode=DUBAI</Link>
        </Text>
        <Text level={3}>
          Affiliate link for ITALY: <Link copyable>https://youvah.fillout.com/t/tBrrvHyqTius?partnerId={partner._id}&programCode=ITALY</Link>
        </Text>
        <Text mark italic>
          Agreement expires on : {dayjs(partner.tenureExpiry).format("DD MMM YYYY")}
        </Text>
      </Space>

      <Row gutter={16} style={{ marginTop: "30px" }}>
        <Col span={6}>
          <Card variant="borderless">
            <Statistic title="Total Commision Earned" value={partner.totalCommisionEarned} precision={2} valueStyle={{ color: "#3f8600" }} prefix="₹" />
          </Card>
        </Col>
        <Col span={6}>
          <Card variant="borderless">
            <Statistic title="Commision Pending" value={partner.commisionPending} precision={2} valueStyle={{ color: "red" }} prefix="₹" />
          </Card>
        </Col>
        <Col span={6}>
          <Card variant="borderless">
            <Statistic title="Total Users" value={partner.totalActiveUsers} valueStyle={{ color: "#000" }} />
          </Card>
        </Col>
        <Col span={6}>
          <Card variant="borderless">
            <Statistic title="Users in this Tenure" value={partner.tenureActiveUsers} valueStyle={{ color: "#971eff" }} />
          </Card>
        </Col>
      </Row>
      <Button
        type="primary"
        style={{ marginTop: "20px" }}
        onClick={() => {
          navigate("/counsellor/leads");
        }}
      >
        Manage your users <ArrowRightOutlined />
      </Button>
    </div>
  );
}

export default Home;
